import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { PwaInstallProvider } from './hooks/usePwaInstall'
import { SocioPortalProvider } from './contexts/SocioPortalContext'
import './styles.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <PwaInstallProvider>
        <SocioPortalProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </SocioPortalProvider>
      </PwaInstallProvider>
    </BrowserRouter>
  </StrictMode>,
)
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('No fue posible registrar el service worker.', error)
    })
  })
} else if (process.env.NODE_ENV === 'development' && 'serviceWorker' in navigator) {
  // Limpia instalaciones antiguas de localhost. Si un service worker controlaba
  // esta página, el bundle pudo venir de su caché: se recarga una sola vez.
  const RELOAD_FLAG = 'cspah-sw-cleanup-reload'
  const controlled = Boolean(navigator.serviceWorker.controller)
  Promise.all([
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister()))),
    'caches' in window
      ? caches.keys().then((keys) => Promise.all(keys.filter((key) => key.startsWith('cspah-shell-')).map((key) => caches.delete(key))))
      : null,
  ])
    .then(() => {
      if (controlled && !sessionStorage.getItem(RELOAD_FLAG)) {
        sessionStorage.setItem(RELOAD_FLAG, '1')
        window.location.reload()
      } else if (!controlled) {
        sessionStorage.removeItem(RELOAD_FLAG)
      }
    })
    .catch(() => {})
}
